<template>
    <div class="w:100% rel">
        <slot></slot>
    </div>
</template>
